import { useState } from 'react';
import * as React from 'react';

import useEnterpriseMegaMenuLinks, {
  useEnterpriseOrgScopedMenuLinks,
} from 'bundles/composable-page-header-enterprise/hooks/useEnterpriseMegaMenuLinks';
import ExploreSubPage from 'bundles/composable-page-header/components/mobile-menu-items/ExploreSubPage';
import type { MobileExploreIdentifierValues } from 'bundles/composable-page-header/constants';
import MegaMenuLinksProvider from 'bundles/megamenu/providers/MegaMenuLinksProvider';
import type { MenuItem } from 'bundles/megamenu/types/MenuData';
import { useOrgSlug } from 'bundles/unified-common/contexts/org-scoped/ThirdPartyOrganizationContext';
import { useIsOrgScopedHome } from 'bundles/unified-common/hooks/useIsOrgScopedHome';

type Props = {
  identifier: MobileExploreIdentifierValues;
};

const EnterpriseExploreSubmenuWrapper = ({ identifier }: Props) => {
  const [exploreViewState, setExploreViewState] = useState<MobileExploreIdentifierValues>(identifier);
  const [currentMenuItem, setMenuItem] = useState<MenuItem | undefined>(undefined);
  const isOrgScopedHome = useIsOrgScopedHome();
  const orgSlug = useOrgSlug();
  const orgScopedLinks = useEnterpriseOrgScopedMenuLinks();
  const megaMenuLinks = useEnterpriseMegaMenuLinks();

  const isOrgScoped = isOrgScopedHome || !!orgSlug;

  const links = isOrgScoped ? orgScopedLinks : megaMenuLinks;

  return (
    <MegaMenuLinksProvider links={links} isEnterprise>
      <ExploreSubPage
        exploreViewState={exploreViewState}
        setExploreViewState={setExploreViewState}
        setMenuItem={setMenuItem}
        currentMenuItem={currentMenuItem}
      />
    </MegaMenuLinksProvider>
  );
};

export default EnterpriseExploreSubmenuWrapper;
